/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../unit_notification_preferences/unit_notification_preferences';
import '../ui_elements/ui_element';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "UnitNotificationPreferencesScreen": {
                    "fields": {
                      "preferences": {
                        "type": ".squareup.bbfrontend.service.v1.UnitNotificationPreferences",
                        "id": 1,
                        "rule": "optional"
                      },
                      "banners": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.BannerElement",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "saveButton": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.UnitNotificationPreferencesScreen) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UnitNotificationPreferencesScreen @ squareup/bbfrontend/common/workflow/screens/unit_notification_preferences_screen.proto at 13:1
 */
export const UnitNotificationPreferencesScreen = $root.lookupType('squareup.bbfrontend.service.v1.UnitNotificationPreferencesScreen');
fixType(UnitNotificationPreferencesScreen, {
  preferences: {
    required: true
  }
});
Builder.createAndAttachToType(UnitNotificationPreferencesScreen);